import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";

/* Google Stars Product Rating Component */
export default function ProductRating({}) {
  return (
    <div className="product-ratings">
      <span aria-hidden="true">4.8</span>
      <RatingStars>
        <FontAwesomeIcon icon={faStar} />
        <FontAwesomeIcon icon={faStar} />
        <FontAwesomeIcon icon={faStar} />
        <FontAwesomeIcon icon={faStar} />
        <FontAwesomeIcon icon={faStarHalfStroke} />
      </RatingStars>
      <span className="google-text">on Google</span>
    </div>
  );
}

const RatingStars = styled.span`
  margin-left: 8px;
  font-size: 14px;
  color: #F8AB07;
  padding-right: 4px;
`;
